import React from 'react'
import styled from 'styled-components'

const PlaceholderThumbnail = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.forecast.cardGroupBackground};
  border-radius: 0.25rem;
`

const StyledThumbnail = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 0.25rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const Thumbnail: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return children ? (
    <StyledThumbnail>{children}</StyledThumbnail>
  ) : (
    <StyledThumbnail>
      <PlaceholderThumbnail />
    </StyledThumbnail>
  )
}
